export default "__VITE_ASSET__ChygKQJf__"